define( 'views/beforeFormContent',[], function( ) {

    var view = Marionette.ItemView.extend({
        tagName: "nf-section",
        template: "#tmpl-nf-before-fields",

        templateHelpers: function () {
            return {

                renderFieldsMarkedRequired: function() {
                    var requiredFields = this.fields.filter( { required: 1 } );
                    return ( requiredFields.length ) ? nfi18n.fieldsMarkedRequired : '';
                },
            };
        },

    });

    return view;
} );
